import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { isiOSPlatform, isAndroidPlatform } from "@swiggy-private/core-ui";

export const OCR_MIN_SUPPORT_VERSIONS = {
    ANDROID: 1715,
    IOS: 750,
};

export const isOcrSupported = (): boolean => {
    const platform = GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform) || "";
    const versionCode = parseInt(GlobalHeaderState.getHeader(SwgyHeaderKeysList.versionCode) || "", 10);

    if (isNaN(versionCode)) return false;

    if (isiOSPlatform(platform)) {
        return versionCode >= OCR_MIN_SUPPORT_VERSIONS.IOS;
    }

    if (isAndroidPlatform(platform)) {
        return versionCode >= OCR_MIN_SUPPORT_VERSIONS.ANDROID;
    }

    return false;
};
